<template>
  <div>
    <VueSlickCarousel :dots="true" :arrows="false" v-bind="slickOptions">
      <div class="member-block" v-for="(member, index) in team" :key="index">
        <div class="tiles">
          <a :href="member.linkedin" target="_blank" class="tile">
            <img
              v-imagekit.src="{
                image: member.picture,
                transform: 'w-120,h-120,fo-face'
              }"
              alt=""
            />
            <div class="content">
              <h6>{{ member.name }}</h6>
              <p>{{ member.title }}</p>
            </div>
          </a>
        </div>
      </div>
    </VueSlickCarousel>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default {
  name: 'team-slider',

  components: {
    VueSlickCarousel
  },

  props: {
    team: {
      type: Array,
      default: []
    }
  },

  data() {
    return {
      slickOptions: {
        autoplay: false,
        centerMode: true,
        focusOnSelect: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        speed: 500,
        variableWidth: true,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              centerPadding: '10px',
              rows: 15,
              slidesPerRow: 1,
              variableWidth: false,
              dots: false,
              infinite: false,
              slidesToShow: 0
            }
          }
        ]
      }
    };
  }
};
</script>
<style>
.slick-slide {
  opacity: 0.3;
  padding-left: 20px;
  padding-right: 20px;
}
.slick-slide:hover {
  opacity: 1;
}
.slick-active.slick-center {
  opacity: 1;
}

@media (min-width: 769px) {
  .slick-list {
    height: 226px;
  }
  .slick-active.slick-center .tiles::before {
    content: '';
    border: 5px solid var(--cs-primary-base);
    width: 35px;
    height: 35px;
    position: absolute;
    left: 34px;
    top: 0;
    border-radius: 50%;
  }
}

.slick-dots li.slick-active button:before {
  color: var(--cs-primary-base);
}
.slick-dots li button:before {
  font-size: 15px;
  color: #ffffff;
}
.slick-dots li {
  width: 15px;
}
.slick-dots {
  bottom: -55px;
}
</style>

<style lang="scss" scoped>
.tiles {
  position: relative;
  outline: none;
  width: 100%;
  margin-bottom: 30px;
  @include media-breakpoint-up(md) {
    width: 200px;
  }

  .tile {
    display: flex;
    align-items: center;
    max-width: 350px;
    margin: 0 auto;
    @include media-breakpoint-up(md) {
      display: block;
      max-width: 100%;
    }
  }

  .content {
    width: 80%;
    text-align: left;
    margin-left: 20px;
    @include media-breakpoint-up(md) {
      width: 100%;
      text-align: center;
      margin-left: 0;
    }
    h6 {
      text-transform: capitalize;
    }
  }
  a {
    text-decoration: none;
    color: #ffffff;
  }
}

img {
  max-width: 85px;
  border-radius: 50%;
  margin: 0 auto;
  @include media-breakpoint-up(md) {
    max-width: 120px;
  }
}

h6 {
  margin-top: 10px;
  font-size: 18px;
  line-height: 24px;
  font-weight: 700;
}

.member-block {
  outline: none;
}
</style>
